import React from "react";
import isMobile from "ismobilejs";
import { withStyles } from "material-ui/styles";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Button from "material-ui/Button";
import MenuIcon from "material-ui-icons/Menu";
import { IconButton } from "material-ui";
import { Manager, Target } from "react-popper";
import { isPreview } from "utils/formatter";
import storage from "utils/storage";
import appLogo from "assets/images/logo.png";

import HeaderMenu from "./HeaderMenu";

const browserStyles = theme => ({
  appBarRoot: {
    backgroundColor: theme.palette.primary.light
  },
  toolbar: {
    display: "flex"
  },
  headerLeftItem: {
    flex: 1,
  },
  appLogo: {
    height: 40,
    verticalAlign: "middle",
    borderRadius: 2
  },
  customerName: {
    marginLeft: 5,
    fontSize: "0.8rem",
    textAlign: "center",
    verticalAlign: "middle"
  },
  surveyName: {
    flex: 1,
    textAlign: "center",
    fontSize: "1.2rem"
  },
  logoutBtnWrapper: {
    flex: 1,
    textAlign: "right"
  },
  spacer: {
    height: 64
  }
});

const mobileStyles = theme => ({
  appBarRoot: {
    backgroundColor: theme.palette.primary.light
  },
  toolbar: {
    padding: "0 5px"
  },
  headerLeftItem: {
    flex: 1
  },
  title: {
    marginLeft: 10,
    fontSize: "1.2rem"
  },
  icon: {
    color: "white"
  },
  spacer: {
    height: 56
  }
});

const Header = props => {
  const { classes, answerHeader } = props;
  const { customerName, surveyName, menuAnchorEl, isOpenMenu } = answerHeader;
  const { handleLogout, openMenu, closeMenu, historyPush } = props;
  const isPreviewAdmin = isPreview() && storage.getPreviewRole() === "admin";

  return (
    <div>
      <AppBar
        position="fixed"
        classes={{
          root: isPreviewAdmin ? "" : classes.appBarRoot
        }}
      >
        {!isMobile.any && (
          <Toolbar className={classes.toolbar}>
            <div className={classes.headerLeftItem}>
              <div>
                <img src={appLogo} alt="" className={classes.appLogo} />
              </div>
              <span className={classes.customerName}>{customerName}</span>
            </div>

            <span className={classes.surveyName}>{surveyName}</span>

            <div className={classes.logoutBtnWrapper}>
              <Button onClick={handleLogout}>
                {isPreview() ? "閉じる" : "ログアウト"}
              </Button>
            </div>
          </Toolbar>
        )}

        {isMobile.any && (
          <Toolbar className={classes.toolbar}>
            <div className={props.classes.headerLeftItem}>
              <span className={classes.title}>NiserES</span>
            </div>

            <Manager>
              <Target>
                <IconButton
                  className={classes.icon}
                  label="Menu"
                  onClick={openMenu}
                >
                  <MenuIcon />
                </IconButton>
              </Target>

              <HeaderMenu
                anchorEl={menuAnchorEl}
                closeMenu={closeMenu}
                open={isOpenMenu}
                historyPush={historyPush}
                handleLogout={handleLogout}
                customerName={customerName}
                surveyName={surveyName}
              />
            </Manager>
          </Toolbar>
        )}
      </AppBar>

      <div className={classes.spacer} />
    </div>
  );
};

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(Header);



// WEBPACK FOOTER //
// ./src/components/answer/Header.jsx